module.exports = __webpack_public_path__ + "img/03.549cd003.jpg";